// extracted by mini-css-extract-plugin
module.exports = {"icon":"WorkspaceBadge_icon__LpDrk","tile":"WorkspaceBadge_tile__Z19iC"};